import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";

const FindCare = () => {
  const navigate = useNavigate();
  const contract = useSelector((state) => state.userData);
  const token = localStorage.getItem("AccessToken");
  const { t } = useTranslation();
  
  const [bookanappointment, setBookanappointment] = useState("N");
  const [findCareProvider, setFindCareProvider] = useState("N");
  const [networkProvider, setNetworkProvider] = useState("No");
  const [loading, setLoading] = useState(true);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  useEffect(() => {
    setLoading(true); // Ensure loader shows on every API call
    const fetchBenefits = async () => {
      if (!contract.userData?.EmailID) {
        setLoading(false);
        return; // Prevent unnecessary API calls if EmailID is missing
      }

      const payload = {
        _Params: JSON.stringify({ EmailID: contract.userData.EmailID, MemberID: contract.userData.MemberID , DeviceType: "PatientPortal" }),
      };

      try {
        const response = await axios.post(Endpoints.UnderstandingBenefits, payload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        });
        setBookanappointment(response.data.Bookanappointment || "N");
        setFindCareProvider(response.data.FindCareProvider || "N");
        setNetworkProvider(response.data.NetworkProvider || "No");
      } catch (error) {
        console.error("Error fetching benefits:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBenefits();
  }, [contract.userData?.EmailID, token]);

  const handleBackClick = () => {
    navigate("/home");
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
      {isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">{t('findcare')}</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t('Back')}
            </span>
          </button>       
          <h2 className="page-heading">{t('findcare')}</h2>
        </div>
      }

      <div className="d-flex flex-wrap gap-5 row pe-0">
        {bookanappointment === "Y" && (
          <div className="flex-item col-md-6 mt-md-3 mt-sm-0 pe-0">
            <Link to="/book-appointment" className="find-care-wrapper book-an-appointment">
              <span className="link-wrapper">{t('bookanappointment')}</span>
            </Link>
          </div>
        )}
        
        {networkProvider === "Yes" && (
          <div className="flex-item col-md-6 mt-3 pe-0 mb-5 mb-md-0">
            <Link to="/load-findcare-list" className="find-care-wrapper find-provider-near-you">
              <span className="link-wrapper">{t('nearprovider')}</span>
            </Link>
          </div>
        )}

        {/* Show this message if BOTH flags are "N" */}
        {bookanappointment === "N" && networkProvider === "No" && (
          <div className="text-center mt-5">
            {/* <p className="text-danger">No find care's avaialble</p> */}
          </div>
        )}
      </div>
    </>
  );
};

export default FindCare;
